import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Permission } from 'src/app/common/enums/permissions';
import { AuthService } from 'src/app/core/authentication/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AbsencesGuard {
  private router = inject(Router);
  private authService = inject(AuthService);

  constructor() { }
  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.hasAbsencePermissions()) {
      return true;
    }

    const workerId = this.tryGetWorkerIdFromUrl(state.url);

    if (workerId != null) {
      this.router.navigate(['/profile', workerId, 'agreements']);
    } else {
      this.router.navigate(['/profile']);
    }

    return false;
  }

  private hasAbsencePermissions(): boolean {
    return (
      this.authService.hasPermission(Permission.ViewMyAbsences) ||
      this.authService.hasPermission(Permission.ViewWorkerAbsences) ||
      this.authService.hasPermission(Permission.ViewAbsenceOnWorkerProfile)
    );
  }

  private tryGetWorkerIdFromUrl(url: string): number | null {
    const pathSegments = url.split('?')[0].split('/').filter(Boolean);
    const profileSegmentIndex = pathSegments.indexOf('profile');

    if (profileSegmentIndex < 0) {
      return null;
    }

    const workerId = Number(pathSegments[profileSegmentIndex + 1]);
    return Number.isFinite(workerId) ? workerId : null;
  }
}
